export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref9347.1b0bf95a.jpg";